export default __webpack_public_path__ + "static/floorplan-e00b3a810077f675fd0ad04dc8cda6e1.png";